import './Funcion.css'

export const Funcion = (props) => {
  return (
    <div className="funcion-box">
      <div className="funcion-image">
        <img src={props.image} alt='' />
      </div>
      <div className="funcion-text">
        {props.title}
      </div>
      <div className="funcion-text-sub">
        {props.sub}
      </div>
    </div>
  );
};

export default Funcion;
